import { useEffect, useState } from 'react';
import CustomAppBar from '../../components/CustomAppBar';
import { Box, Card, CircularProgress, Container, Grid, IconButton, Typography, useTheme } from "@mui/material";
import { PlayArrowRounded } from '@mui/icons-material';
import { connect, useDispatch } from 'react-redux';
import { homePageActions } from '../../store/reducer/home';
import { useNavigate } from 'react-router-dom';
import AlertBar from '../../components/AlertBar';
import { isEmpty } from 'lodash';
import { ReactComponent as TimerIcon } from '../../assets/timer-start-svgrepo-com.svg';

const RegularGames = ({ homePageData, isHomeLoading }: any) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const [pageData, setPageData] = useState<any>([])
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const data: any = {
            app_key: "@34Y@#8deepmatka",
            user_id: 0,
            player_id: 0
        };
        dispatch(homePageActions.dashboardDataRequest(data))
        const pay: any = {
            menuname: 'regular-games'
        }
        dispatch(homePageActions.selectedMenu(pay))
    }, [])

    useEffect(() => {
        if (Object.keys(homePageData).length) {
            setPageData(homePageData.result)
        }
    }, [homePageData, isHomeLoading])

    // Update current time every second for countdown timer
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    // Function to calculate remaining time until result time
    const getRemainingTime = (resultTime: string) => {
        if (!resultTime) return null;
        
        try {
            const today = currentTime; // Use currentTime state that updates every second
            const [time, period] = resultTime.split(' ');
            const [hours, minutes] = time.split(':');
            
            let resultHour = parseInt(hours);
            const resultMinute = parseInt(minutes);
            
            // Convert to 24-hour format
            if (period === 'PM' && resultHour !== 12) {
                resultHour += 12;
            } else if (period === 'AM' && resultHour === 12) {
                resultHour = 0;
            }
            
            // Create target date for today
            const targetDate = new Date(today);
            targetDate.setHours(resultHour, resultMinute, 0, 0);
            
            // If target time has passed today, set it for tomorrow
            if (targetDate <= today) {
                targetDate.setDate(targetDate.getDate() + 1);
            }
            
            const diff = targetDate.getTime() - today.getTime();
            
            if (diff <= 0) return null;
            
            const hoursLeft = Math.floor(diff / (1000 * 60 * 60));
            const minutesLeft = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const secondsLeft = Math.floor((diff % (1000 * 60)) / 1000);
            
            return {
                hours: hoursLeft,
                minutes: minutesLeft,
                seconds: secondsLeft,
                formatted: `${String(hoursLeft).padStart(2, '0')}:${String(minutesLeft).padStart(2, '0')}:${String(secondsLeft).padStart(2, '0')}`
            };
        } catch (error) {
            return null;
        }
    };

    const handleCardClick = (event: any, item: any) => {
        if (item.msg_status === 1) {
            // Navigate to game list page first (gameplay/index.tsx)
            navigate('/play-game/' + item.game_id)
        } else {
            setErrorMessage({ status: true, message: "Game is closed for today.", severity: 'error', inputName: '' })
        }
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    return (
        <div>
            <CustomAppBar pageName={'Regular Games'} />
            {isHomeLoading ? 
                <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}> 
                    <CircularProgress /> 
                </div> :
                <Container sx={{ paddingLeft: '0px !important', paddingRight: '0px !important', marginTop: '70px !important', paddingBottom: '50px' }}>
                    <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', padding: '5px' }}>
                        {(pageData.length) ? pageData.map((item: any, index: number) => (
                            <Grid xs={12} lg={3} md={4} sm={4} margin={1} key={index}>
                                <Card variant="outlined"
                                    onClick={(event: any) => handleCardClick(event, item)}
                                    sx={{
                                        borderRadius: '22px',
                                        boxShadow: theme.shadows[4],
                                        border: `2px solid ${theme.palette.divider}`,
                                        padding: '15px',
                                        backgroundColor: theme.palette.background.paper,
                                        cursor: 'pointer',
                                        '&:hover': {
                                            transform: 'translateY(-4px)',
                                            boxShadow: theme.shadows[8],
                                            borderColor: theme.palette.primary.main,
                                        },
                                        transition: 'all 0.3s ease',
                                    }}>
                                    <Box sx={{ 
                                        display: 'flex', 
                                        color: theme.palette.text.primary, 
                                        padding: '5px', 
                                        flexDirection: 'row', 
                                        justifyContent: 'space-between', 
                                        alignItems: 'center' 
                                    }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: '0px 8px 0px 8px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                            <Typography sx={{ 
                                                textAlign: 'center', 
                                                color: theme.palette.text.primary, 
                                                fontFamily: 'Poppins', 
                                                fontSize: '1.8rem', 
                                                fontWeight: '800', 
                                                lineHeight: 1,
                                            }}>
                                                {item.game_name}
                                            </Typography>
                                            <Typography sx={{ 
                                                marginTop:'5px',
                                                textAlign: 'center', 
                                                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                fontFamily: 'Poppins', 
                                                fontSize: '1.5rem', 
                                                fontWeight: '900', 
                                                lineHeight: 1 
                                            }}>
                                                {(item.open_result != '') ? item.open_result : '***-*'}{(item.close_result != '') ? item.close_result : '*-***'}
                                            </Typography>
                                            <Box sx={{ marginTop:'8px', display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography sx={{ color: theme.palette.text.secondary, fontFamily: 'Poppins', fontSize: '0.75rem', fontWeight: '500', lineHeight: 1 }}>
                                                      Open Time -  Close Time
                                                </Typography>
                                            </Box>
                                            <Box sx={{ marginTop:'5px', display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography sx={{ color: theme.palette.text.primary, fontFamily: 'Poppins', fontSize: '0.85rem', fontWeight: '600', lineHeight: 1 }}>
                                                      {item.open_time} -  {item.close_time}
                                                </Typography>
                                            </Box>
                                            {/* Countdown Timers */}
                                            <Box sx={{ marginTop: '10px', display: 'flex', flexDirection: 'column', paddingLeft: '5px', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', width: '100%' }}>
                                                {(() => {
                                                    const openRemaining = getRemainingTime(item.open_time);
                                                    const closeRemaining = getRemainingTime(item.close_time);
                                                    return (
                                                        <>
                                                            {openRemaining && item.msg_status === 1 && (
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '6px',
                                                                    padding: '4px 8px',
                                                                    borderRadius: '8px',
                                                                    backgroundColor: theme.palette.mode === 'light' 
                                                                        ? 'rgba(82, 201, 162, 0.1)' 
                                                                        : 'rgba(82, 201, 162, 0.2)',
                                                                    border: `1px solid ${theme.palette.success.light}`,
                                                                    width: '100%',
                                                                }}>
                                                                    <TimerIcon style={{ width: '14px', height: '14px', color: theme.palette.success.main }} />
                                                                    <Typography sx={{ 
                                                                        color: theme.palette.success.main, 
                                                                        fontFamily: 'Poppins', 
                                                                        fontSize: '0.75rem', 
                                                                        fontWeight: '700', 
                                                                        lineHeight: 1,
                                                                        letterSpacing: '0.5px',
                                                                    }}>
                                                                        Open Remain: {openRemaining.formatted}
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                            {closeRemaining && item.msg_status === 1 && (
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '6px',
                                                                    padding: '4px 8px',
                                                                    borderRadius: '8px',
                                                                    backgroundColor: theme.palette.mode === 'light' 
                                                                        ? 'rgba(255, 107, 107, 0.1)' 
                                                                        : 'rgba(255, 107, 107, 0.2)',
                                                                    border: `1px solid ${theme.palette.error.light}`,
                                                                    width: '100%',
                                                                }}>
                                                                    <TimerIcon style={{ width: '14px', height: '14px', color: theme.palette.error.main }} />
                                                                    <Typography sx={{ 
                                                                        color: theme.palette.error.main, 
                                                                        fontFamily: 'Poppins', 
                                                                        fontSize: '0.75rem', 
                                                                        fontWeight: '700', 
                                                                        lineHeight: 1,
                                                                        letterSpacing: '0.5px',
                                                                    }}>
                                                                        Close Remain: {closeRemaining.formatted}
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                            </Box>
                                        </Box>
                                        <IconButton sx={{
                                            borderRadius: '18px', height: '100px', width: '100px', padding: 0,
                                            display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', boxShadow: '0px 0px 0px #adadad27'
                                        }}>
                                            {(item.msg_status === 1) ? 
                                                <Typography sx={{ fontSize: '10px', color: theme.palette.success.main, marginBottom: '5px', fontWeight: 700 }}>● OPEN</Typography> : 
                                                <Typography sx={{ fontSize: '9px', color: theme.palette.error.main, marginBottom: '2px', fontWeight: 700 }}>● CLOSED</Typography>
                                            }
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'center', 
                                                alignItems: 'center', 
                                                height: '50px', 
                                                width: '50px', 
                                                borderRadius: '50%', 
                                                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                                boxShadow: theme.shadows[4]
                                            }}>
                                                <PlayArrowRounded sx={{ fontSize: '2rem', color: '#FFFFFF' }} /> 
                                            </div>
                                            <Typography sx={{ fontSize: '9px', color: theme.palette.text.secondary, marginBottom: '0px', marginTop: '5px', fontWeight: 600 }}>Play game</Typography>
                                        </IconButton>
                                    </Box>
                                </Card>
                            </Grid>
                        )) : isHomeLoading ? '' : 
                            <Grid xs={12} sx={{textAlign: 'center', padding: '50px'}}>
                                <Typography>No games available</Typography>
                            </Grid>
                        }
                    </Grid>
                </Container>
            }
            <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    homePageData: state.homepage.homePageData,
    isHomeLoading: state.homepage.isHomeLoading,
})

export default connect(mapStateToProps)(RegularGames);

